import { powerSupplySteps } from "../constants";
import PowerSupplyGroup from "./PowerSupplyGroup";
import _Model from "./_Model";

export default class PowerSupplyManagement extends _Model {
  constructor(json) {
    super(json);
    this.step = PowerSupplyManagement.getOrDefault(json, 'step', powerSupplySteps.requirements);
    this.powerSupplyGroups = PowerSupplyManagement.getMappedOrDefault(json, 'powerSupplyGroups', [], data => (data || []).map(d => new PowerSupplyGroup(d || {})));
    this.isEdited = PowerSupplyManagement.getOrDefault(json, 'isEdited', false);
    this.requirements =  PowerSupplyManagement.getOrDefault(json, 'requirements', {});
  }
}
